import {Select, SelectProps} from '@mantine/core'
import {useState} from 'react'
import {useThemeMode} from '../../_metronic/partials'

function Select2(props: SelectProps) {
  const {mode} = useThemeMode()
  const [searchValue, onSearchChange] = useState('')

  const themeStyles = {
    input: {
      backgroundColor: mode === 'dark' ? '#1e1e2d' : 'var(--bs-body-bg)',
      color: mode === 'dark' ? 'var(--bs-gray-100)' : 'var(--bs-gray-700)',
      border: `1px solid ${mode === 'dark' ? 'var(--bs-gray-600)' : 'var(--bs-gray-300)'}`,
      borderRadius: '0.475rem',
      '&::placeholder': {
        color: mode === 'dark' ? 'var(--bs-gray-500)' : 'var(--bs-gray-600)',
        opacity: 1,
      },
      '&:hover:not(:disabled)': {
        borderColor: mode === 'dark' ? 'var(--bs-gray-500)' : 'var(--bs-gray-400)',
      },
      '&:focus': {
        borderColor: 'var(--bs-primary)',
        boxShadow: `0 0 0 0.15rem ${mode === 'dark' ? 'rgba(0, 158, 247, 0.2)' : 'rgba(0, 158, 247, 0.15)'}`,
      },
      '&:disabled': {
        backgroundColor: mode === 'dark' ? '#151521' : 'var(--bs-gray-100)',
        color: mode === 'dark' ? 'var(--bs-gray-500)' : 'var(--bs-gray-500)',
        opacity: 1,
      },
      '&[aria-invalid="true"]': {
        borderColor: 'var(--bs-danger)',
      },
    },
    item: {
      fontSize: '13px',
      color: mode === 'dark' ? 'var(--bs-gray-100)' : 'var(--bs-gray-800)',
      paddingTop: '0.55rem',
      paddingBottom: '0.55rem',
      '&:hover, &[data-hovered]': {
        backgroundColor: mode === 'dark' ? '#323248' : 'var(--bs-gray-200)',
      },
      '&[data-selected]': {
        backgroundColor: mode === 'dark' ? '#2b2b40' : 'var(--bs-primary-light)',
        color: mode === 'dark' ? 'var(--bs-gray-100)' : 'var(--bs-primary)',
      },
      '&:focus-visible': {
        outline: `2px solid var(--bs-primary)`,
        outlineOffset: '-2px',
      },
    },
    dropdown: {
      backgroundColor: mode === 'dark' ? '#1e1e2d' : 'white',
      border: `1px solid ${mode === 'dark' ? 'var(--bs-gray-600)' : 'var(--bs-gray-300)'}`,
      borderRadius: '0.475rem',
      padding: '0.25rem',
    },
  }

  return (
    <Select
      {...props}
      size={props.size ?? 'lg'}
      dropdownPosition={props.dropdownPosition ?? 'flip'}
      withinPortal={props.withinPortal ?? true}
      zIndex={props.zIndex ?? 1060}
      maxDropdownHeight={props.maxDropdownHeight ?? 220}
      placeholder={props.placeholder ?? 'Select...'}
      searchable
      onSearchChange={onSearchChange}
      searchValue={searchValue}
      nothingFound='No options'
      styles={
        props?.styles !== undefined
          ? props.styles
          : (theme) => ({
              ...theme,
              ...themeStyles,
              '&[data-focus]': {
                borderColor: 'var(--bs-primary)',
              },
            })
      }
    />
  )
}

export default Select2
